import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { FloorTypeRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: FloorTypeRow[];
  loading?: boolean;
};

const FloorTypeTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "floorTypeId",
        label: t("FLOOR_TYPE.TABLE.NUMBER"),
        align: "right",
        width: "56px",
        minWidth: "56px",
        format: (row: FloorTypeRow) => (
          <span className={styles.numberCell}>{row.floorTypeId}</span>
        ),
      },
      {
        id: "floorTypeName",
        label: t("FLOOR_TYPE.TABLE.DESCRIPTION"),
        align: "right",
        format: (row: FloorTypeRow) => (
          <span className={styles.textCell}>{row.floorTypeName}</span>
        ),
      },
    ],
    [styles, t],
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        scrollClass="custom-scroll-bar"
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("FLOOR_TYPE.EMPTY")}
      />
    </div>
  );
};

export default FloorTypeTable;
